import React from "react";
import { BlockMath, InlineMath } from "../../../../components/math/KatexWrappers";
import FractionInput from "../../../../components/inputs/FractionInput";
import {
  constantTerm,
  isCorrectNumber,
  leadingTerm,
  polynomialLatex,
  randInt,
  renderPreview,
  taskTags,
} from "./helpers";

function createPolynomial() {
  const degree = randInt(3, 6);
  const terms = [
    { degree, coefficient: randInt(2, 7) * (Math.random() < 0.5 ? -1 : 1) },
    { degree: randInt(1, degree - 1), coefficient: randInt(2, 9) * (Math.random() < 0.5 ? -1 : 1) },
    { degree: 1, coefficient: randInt(2, 9) * (Math.random() < 0.5 ? -1 : 1) },
    { degree: 0, coefficient: randInt(-9, 9) || 4 },
  ];
  return { terms, degree };
}

export function generateTask() {
  return {
    type: "PolynomialDegreeTask",
    points: 1,
    data: createPolynomial(),
    tags: taskTags(["stopien_wielomianu"]),
  };
}

export function renderTask(task) {
  return (
    <>
      <p>Wyznacz stopień wielomianu.</p>
      <BlockMath math={`W(x)=${polynomialLatex(task.data.terms)}`} />
    </>
  );
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      label="\\deg W"
      value={userAnswer?.degree ?? ""}
      onChange={(value) => onChange({ ...(userAnswer || {}), degree: value })}
      disabled={disabled}
      placeholder="np. 4"
      panelWidthDesktop={180}
    />
  );
}

export function checkAnswer(task, userAnswer) {
  const correct = isCorrectNumber(userAnswer?.degree, task.data.degree);
  return { correct, points: correct ? 1 : 0 };
}

export function renderAnswer(task) {
  return <InlineMath math={`\\deg W=${task.data.degree}`} />;
}

export function renderUserAnswer(userAnswer) {
  return renderPreview(userAnswer?.degree, "\\deg W");
}

export function renderExplanation(task) {
  const leading = leadingTerm(task.data.terms);
  return (
    <div>
      <p>
        <strong>Krok 1.</strong> Szukamy wyrazu z najwyższą potęgą zmiennej.
      </p>
      <BlockMath math={`W(x)=${polynomialLatex(task.data.terms)}`} />
      <p>
        Najwyższa potęga występuje w wyrazie{" "}
        <InlineMath math={`${leading.coefficient}x^{${leading.degree}}`} />.
      </p>
      <p>
        Wyraz wolny tego wielomianu to <InlineMath math={`${constantTerm(task.data.terms)}`} />.
      </p>
      <p>
        <strong>Odpowiedź:</strong> <InlineMath math={`\\deg W=${task.data.degree}`} />.
      </p>
    </div>
  );
}
